module.exports = __webpack_public_path__ + "img/footerbackground.b4467ec2.png";